<template>
  <div class="spotlight-inner-wrapper">
    <Hero :title="$t('message.spotlight.sxm.form.title')" :text="$t('message.spotlight.sxm.form.text')"></Hero>
    <mobialis-form-with-validation @onValidate="submit">
      <div>
        <mobialis-text-input-with-validation
          :rules="{ required: true, regex: /^([^0-9]*)$/ }"
          :label="$t('message.common.firstName')"
          v-model="firstName"
          vid="firstName"
          data-cy="firstName"
        ></mobialis-text-input-with-validation>
        <mobialis-text-input-with-validation
          :rules="{ required: true, regex: /^([^0-9]*)$/ }"
          :label="$t('message.common.lastName')"
          v-model="lastName"
          vid="lastName"
          data-cy="lastName"
        ></mobialis-text-input-with-validation>
        <mobialis-text-input-with-validation
          class="phone-number"
          rules="required|length:10"
          :label="$t('message.common.phoneNumber')"
          v-model="phoneNumber"
          vid="phoneNumber"
          placeholder="(   )"
          mask-type="phoneNumber"
          type="tel"
          data-cy="phoneNumber"
        ></mobialis-text-input-with-validation>
        <mobialis-text-input-with-validation
          rules="required|email"
          :label="$t('message.common.emailAddress')"
          v-model="emailAddress"
          vid="emailAddress"
          data-cy="emailAddress"
          type="email"
        ></mobialis-text-input-with-validation>
        <mobialis-check-box-with-validation
          rules="required:true"
          :label="$t('message.spotlight.sxm.form.tandc', { dealershipName: getBusinessName })"
          vid="tandc"
          id="tandc"
          data-cy="tAndC"
        ></mobialis-check-box-with-validation>
      </div>
      <mobialis-button data-cy="submit" type="submit" class="mt-4 mb-1">{{
        $t('message.spotlight.sxm.form.buttonText')
      }}</mobialis-button>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Hero from '@/modules/spotlight/components/Hero.vue';
import log from '@/services/log';
import { enumMixin } from '@/mixins';

export default {
  name: 'ReportRequest',
  mixins: [enumMixin],
  components: {
    Hero,
  },
  computed: {
    ...mapGetters('business', ['getBusinessName']),
    firstName: {
      get() {
        return this.$store.state.user.firstName;
      },
      set(value) {
        this.$store.commit('user/SET_FIRST_NAME', value);
      },
    },
    lastName: {
      get() {
        return this.$store.state.user.lastName;
      },
      set(value) {
        this.$store.commit('user/SET_LAST_NAME', value);
      },
    },
    emailAddress: {
      get() {
        return this.$store.state.user.emailAddress;
      },
      set(value) {
        this.$store.commit('user/SET_EMAIL_ADDRESS', value);
      },
    },
    phoneNumber: {
      get() {
        return this.$store.state.user.phoneNumber;
      },
      set(value) {
        this.$store.commit('user/SET_PHONE_NUMBER', value);
      },
    },
  },
  methods: {
    async submit(isValid) {
      if (!isValid) {
        return;
      }

      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('lead/createLead').catch(error => {
          // Handle an error for create lead
          log('Error in Spotlight report request form - Create lead', error);
          throw error;
        });

        // Form submission event tracking
        this.$ga.event('SiriusXM', 'form_submission', 'report_request_submitted');

        // Analytics tracking
        const payload = {
          elementInteractedWith: 'spotlight.request_form.submitted',
        };
        this.$store.dispatch('metrics/logModalInteraction', payload).catch(error => {
          log('Error in logging interaction', error);
        });

        // Push the route and update lead for route list
        this.$router.push({ name: `spotlight-confirmation-${this.baseRoute}` });

        await this.$store
          .dispatch('lead/updateLead', {
            step: this.enums.LeadStep.SPOTLIGHT,
          })
          .catch(error => {
            // Handle an error for update lead
            log('Error in Spotlight report request form - Update lead', error);
            throw error;
          });
      } catch (error) {
        this.$router.push({ name: `spotlight-error-${this.baseRoute}` });
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.phone-number {
  width: 180px;
  white-space: nowrap;
}
.spotlight-inner-wrapper {
  padding-bottom: 80px;
}
</style>
